/**
 * Texte des Oberflächengerüsts: Navigation, Dashboard, Dialoge und die
 * kurzen Erklärungen hinter den Fragezeichen.
 *
 * Die Erklärungen sind ein bis drei Sätze lang und in Alltagssprache -
 * niemand soll hier Fachbegriffe nachschlagen müssen.
 */
export const deUi = {
  // --- Navigation ---------------------------------------------------------
  'nav.dashboard': 'Dashboard',
  'nav.statistics': 'Statistik',
  'nav.balance': 'Guthaben',
  'nav.settings': 'Einstellungen',
  'nav.language': 'Sprache',
  'nav.main': 'Hauptnavigation',

  // --- Wiederkehrende Aktionen -------------------------------------------
  'action.close': 'Schließen',
  'action.confirm': 'Bestätigen',
  'action.change': 'Ändern',
  'action.remove': 'Entfernen',
  'action.edit': 'Bearbeiten',

  'help.about': 'Erklärung anzeigen',
  'help.aboutLabel': 'Erklärung zu {label}',

  // --- Dashboard ----------------------------------------------------------
  'dashboard.title': 'Dashboard',
  'dashboard.welcome': 'Guten Tag, {name}',
  'dashboard.balance': 'Guthaben',
  'dashboard.minutesToday': 'Gesprächsminuten heute',
  'dashboard.activeCallers': 'Caller online',
  'dashboard.runningCalls': 'Laufende Gespräche',
  'dashboard.campaigns': 'Aktive Kampagnen',
  'dashboard.resultsToday': 'Abschlüsse heute',
  'dashboard.noData': 'Noch keine Zahlen',
  'dashboard.help.balance': 'Ihr aktuelles Prepaid-Guthaben. Sinkt es unter eine Gesprächsminute, können keine neuen Anrufe mehr starten.',
  'dashboard.help.minutesToday': 'Summe der heute tatsächlich verbundenen Gesprächszeit. Klingeln und Wartezeit zählen nicht mit.',
  'dashboard.help.activeCallers': 'Caller, die gerade angemeldet sind und telefonieren könnten.',
  'dashboard.help.runningCalls': 'Gespräche, die in diesem Moment laufen.',
  'dashboard.help.campaigns': 'Kampagnen, die gerade gestartet sind. Gestoppte und archivierte zählen nicht mit.',
  'dashboard.help.resultsToday': 'Heute als erfolgreich abgeschlossene Gespräche.',
  'dashboard.quickStart': 'So kommen Sie los',
  'dashboard.quickStartText': 'Legen Sie eine Kampagne an, importieren Sie Ihre Datensätze und geben Sie sie für Ihre Caller frei.',
  'dashboard.openCampaigns': 'Zu den Kampagnen',

  // --- Noch nicht fertige Bereiche ---------------------------------------
  'soon.title': 'Dieser Bereich ist noch nicht verfügbar',
  'soon.statistics': 'Die Auswertungen zu Gesprächen, Callern und Kampagnen entstehen in einem der nächsten Schritte. Ihre Gespräche werden bereits vollständig protokolliert.',
  'soon.campaignStatistics': 'Die Auswertung dieser Kampagne entsteht in einem der nächsten Schritte.',
  'soon.campaignRecordings': 'Gesprächsaufnahmen entstehen in einem der nächsten Schritte.',
  'soon.hint': 'Sie können hier später weiterarbeiten - es geht nichts verloren.',

  // --- Guthaben -----------------------------------------------------------
  'balance.title': 'Guthaben',
  'balance.current': 'Aktuelles Guthaben',
  'balance.pricePerMinute': 'Preis je Gesprächsminute',
  'balance.help.pricePerMinute': 'Abgerechnet wird nur verbundene Gesprächszeit, aufgerundet auf volle Minuten je Gespräch.',
  'balance.topUp': 'Guthaben aufladen',
  'balance.topUpText': 'Das Aufladen erfolgt über Krypto-Zahlungen. Kartenzahlung ist noch nicht vorgesehen.',
  'balance.amount': 'Betrag in Euro',
  'balance.minimum': 'Mindestbetrag',
  'balance.minimumHint': 'Mindestens {amount} je Aufladung.',
  'balance.payWithCrypto': 'Mit Krypto aufladen',
  'balance.history': 'Zahlungshistorie',
  'balance.historyEmpty': 'Hier erscheinen Ihre Aufladungen und alle weiteren Buchungen.',
  'balance.date': 'Zeitpunkt',
  'balance.amountColumn': 'Betrag',
  'balance.type': 'Art',
  'balance.balanceAfter': 'Guthaben danach',
  'balance.note': 'Hinweis',

  // --- Arten von Buchungen ------------------------------------------------
  'balance.type.topup_nowpayments': 'Guthabenaufladung',
  'balance.type.start_credit': 'Startguthaben',
  'balance.type.manual_credit': 'Gutschrift',
  'balance.type.manual_debit': 'Abbuchung',
  'balance.type.phone_number_order': 'Rufnummernbestellung',
  'balance.type.phone_number_refund': 'Rückerstattung Rufnummernbestellung',
  'balance.type.hosted_sip_monthly_fee': 'Monatliche SIP-Grundgebühr',
  'balance.type.dialer_call': 'Gesprächskosten',
  'balance.type.hosted_sip_call': 'Gesprächskosten über SIP-Anschluss',

  // --- Fehlermeldungen zum Guthaben ---------------------------------------
  'error.billing.below_minimum': 'Bitte laden Sie mindestens {minTopUpAmount} auf.',
  'error.billing.amount_invalid': 'Bitte geben Sie einen Betrag größer als 0 ein.',
  'error.billing.note_too_long': 'Der Hinweis ist zu lang. Bitte kürzen Sie ihn.',
  'error.billing.debit_exceeds_balance': 'Das Guthaben reicht nicht aus. Verfügbar sind {available}.',
  'error.billing.already_booked': 'Diese Buchung wurde bereits ausgeführt.',
  'error.billing.provider_unavailable': 'Die Aufladung ist derzeit nicht möglich. Bitte wenden Sie sich an den Support.',

  // --- Caller-Verwaltung --------------------------------------------------
  'callers.role': 'Rolle',
  'callers.roleAdmin': 'Administrator',
  'callers.roleCaller': 'Caller',
  'callers.roleOwner': 'Kontoinhaber',
  'callers.state': 'Zugang',
  'callers.stateActive': 'Aktiv',
  'callers.stateInactive': 'Gesperrt',
  'callers.createTitle': 'Neuen Caller anlegen',
  'callers.created': 'Der Zugang wurde angelegt.',
  'callers.help.username': 'Mit diesem Namen meldet sich der Caller an. Er muss auf der ganzen Plattform eindeutig sein.',
  'callers.help.admin': 'Administratoren dürfen Kampagnen anlegen, Datensätze verwalten und weitere Zugänge einrichten.',
  'callers.setPasswordTitle': 'Neues Passwort vergeben',
  'callers.setPasswordText': 'Der Caller kann sich danach nur noch mit dem neuen Passwort anmelden. Eine offene Sitzung wird beendet.',
  'callers.setPasswordAction': 'Passwort setzen',
  'callers.deactivateTitle': 'Zugang sperren',
  'callers.deactivateText': 'Der Zugang kann sich danach nicht mehr anmelden. Eine laufende Sitzung wird sofort beendet. Sie können den Zugang jederzeit wieder freigeben.',
  'callers.deactivateAction': 'Zugang sperren',
  'callers.makeAdminTitle': 'Administratorrechte geben',
  'callers.makeAdminText': 'Dieser Zugang darf danach Kampagnen, Datensätze und weitere Zugänge verwalten.',
  'callers.revokeAdminTitle': 'Administratorrechte entziehen',
  'callers.revokeAdminText': 'Dieser Zugang kann danach nur noch telefonieren.',

  // --- Dialoge an anderen Stellen ----------------------------------------
  'dialog.campaignArchive': 'Kampagne archivieren',
  'dialog.campaignArchiveText': 'Die Kampagne verschwindet aus der normalen Übersicht. Datensätze und Gesprächsverlauf bleiben erhalten, und Sie können sie jederzeit zurückholen.',
  'dialog.campaignDelete': 'Kampagne löschen',
  'dialog.campaignDeleteText': 'Die Kampagne und alle zugehörigen Datensätze werden endgültig gelöscht. Das lässt sich nicht rückgängig machen.',
  'dialog.contactDelete': 'Datensatz löschen',
  'dialog.contactDeleteText': 'Der Datensatz wird endgültig gelöscht. Wenn Sie ihn später noch brauchen könnten, archivieren Sie ihn besser.',
  'dialog.modeChange': 'Arbeitsweise der Kampagne ändern',
  'dialog.accountDelete': 'Konto löschen',
  'dialog.leaveCalling': 'Telefoniebereich verlassen?',
  'dialog.leaveCallingText': 'Der Dialer stoppt und Sie können keine Anrufe mehr annehmen.',
  'dialog.leaveCallingAction': 'Verlassen',

  // --- Kampagneneinstellungen: Gliederung --------------------------------
  'campaign.section.general': 'Allgemein',
  'campaign.section.generalHint': 'Name, Beschreibung und die Sprache der Rufnummern.',
  'campaign.section.callers': 'Caller',
  'campaign.section.callersHint': 'Wie die Datensätze auf die Caller verteilt werden.',
  'campaign.section.dialer': 'Dialer',
  'campaign.section.dialerHint': 'Wie viele Gespräche gleichzeitig aufgebaut werden und wie oft es erneut versucht wird.',
  'campaign.section.telephony': 'Telefonie',
  'campaign.section.telephonyHint': 'Der Zugang Ihres Telefonieanbieters für diese Kampagne.',
  'campaign.section.inbound': 'Eingehende Anrufe',
  'campaign.section.inboundHint': 'Ob Kunden in dieser Kampagne zurückrufen können.',
  'campaign.section.queue': 'Warteschleife',
  'campaign.section.queueHint': 'Was passiert, wenn gerade kein Caller frei ist.',
  'campaign.section.recording': 'Aufnahmen',
  'campaign.section.recordingHint': 'Ob Gespräche mitgeschnitten werden.',
  'campaign.section.data': 'Eigene Felder',
  'campaign.section.dataHint': 'Zusätzliche Angaben, die Sie je Datensatz erfassen möchten.',
  'campaign.section.advanced': 'Erweiterte Einstellungen',

  // --- Kampagneneinstellungen: Erklärungen -------------------------------
  'campaign.help.mode': 'Im gemeinsamen Pool arbeiten alle Caller dieselbe Liste ab. Bei fester Zuweisung gehört jeder Datensatz genau einem Caller, und die anderen sehen ihn nicht.',
  'campaign.help.country': 'Wird gebraucht, um Rufnummern ohne Ländervorwahl richtig zu ergänzen - etwa 0176… zu +49176…',
  'campaign.help.parallelCalls': 'Wie viele Rufnummern gleichzeitig angewählt werden, während ein Caller frei ist. Höhere Werte finden schneller jemanden, erhöhen aber das Risiko, dass ein Kunde warten muss.',
  'campaign.help.parallelMode': 'Gilt die Zahl je Caller oder für die ganze Kampagne zusammen?',
  'campaign.help.retry': 'Wie oft eine Rufnummer innerhalb von 24 Stunden erneut versucht wird, wenn niemand abhebt.',
  'campaign.help.mailbox': 'Erkennt Anrufbeantworter und beendet solche Gespräche, damit Ihre Caller keine Bandansage abhören.',
  'campaign.help.inbound': 'Erlaubt, dass Kunden in dieser Kampagne zurückrufen und bei einem freien Caller landen.',
  'campaign.help.queue': 'Hält Anrufer kurz in einer Warteschleife, wenn gerade kein Caller frei ist.',
  'campaign.help.queueWait': 'Nach dieser Zeit wird das Gespräch beendet, wenn niemand frei geworden ist.',
  'campaign.help.recording': 'Legt fest, ob Gespräche in dieser Kampagne standardmäßig aufgezeichnet werden.',
  'campaign.help.fields': 'Zusätzliche Angaben je Datensatz, etwa Ort oder Vertragsnummer. Sie erscheinen beim Telefonieren und im CSV-Import.',
  'campaign.help.required': 'Dieses Feld muss ausgefüllt sein, bevor ein Gespräch abgeschlossen werden kann.',
  'campaign.help.sip': 'Die Zugangsdaten Ihres Telefonieanbieters. Ohne sie kann in dieser Kampagne nicht telefoniert werden.',

  'campaign.settings.sip': 'Telefonieanbieter',

  // --- Telefonieanbieter der Kampagne -------------------------------------
  'campaign.sip.provider': 'Anbieter',
  'campaign.sip.providerHint': 'Nur als Notiz für Sie - z. B. TENIOS, dus.net oder sipgate.',
  'campaign.sip.host': 'SIP-Server',
  'campaign.sip.hostHint': 'Die Adresse, die Ihr Anbieter nennt - ohne „sip:“ davor.',
  'campaign.sip.username': 'Benutzername',
  'campaign.sip.password': 'Passwort',
  'campaign.sip.passwordStored': 'Ein Passwort ist hinterlegt. Leer lassen, um es zu behalten.',
  'campaign.sip.registration': 'Anmeldung beim Anbieter erforderlich',
  'campaign.sip.registrationHelp':
    'Die meisten Anbieter verlangen das. Steht in Ihren Zugangsdaten meist als „Registrierung“ oder „REGISTER“.',
  'campaign.sip.advancedShow': 'Erweiterte Einstellungen anzeigen',
  'campaign.sip.advancedHide': 'Erweiterte Einstellungen ausblenden',
  'campaign.sip.authId': 'Anmeldekennung',
  'campaign.sip.authIdHint': 'Nur ausfüllen, wenn sie vom Benutzernamen abweicht.',
  'campaign.sip.realm': 'Realm',
  'campaign.sip.fromDomain': 'Absenderdomain',
  'campaign.sip.fromDomainHint': 'Nur ausfüllen, wenn Ihr Anbieter eine andere als den Server verlangt.',
  'campaign.sip.port': 'Port',
  'campaign.sip.portHint': 'Leer lassen für den üblichen Port 5060.',
  'campaign.sip.transport': 'Übertragung',
  'campaign.sip.transportDefault': 'Standard',
  'campaign.sip.optional': 'Optional.',
  'campaign.sip.expiration': 'Anmeldung gültig (Sekunden)',
  'campaign.sip.expirationHint': 'Leer lassen für den Standardwert.',
  'campaign.sip.retryInterval': 'Abstand neuer Versuche (Sekunden)',
  'campaign.sip.retryIntervalHint': 'Leer lassen für den Standardwert.',
  'campaign.sip.saved': 'Die Zugangsdaten wurden gespeichert.',
  'campaign.sip.test': 'Verbindung testen',
  'campaign.sip.testing': 'Wird getestet …',
  'campaign.sip.test.ok': 'Die Telefonie ist bereit.',
  'campaign.sip.test.registered': 'Verbunden - die Anmeldung beim Anbieter war erfolgreich.',
  'campaign.sip.test.registration_failed':
    'Die Anmeldung beim Anbieter ist fehlgeschlagen. Bitte prüfen Sie Server und Zugangsdaten.',
  'campaign.sip.test.rejected': 'Der Anbieter hat die Zugangsdaten abgelehnt.',
  'campaign.sip.test.unreachable': 'Der Server des Anbieters ist nicht erreichbar.',
  'campaign.sip.test.timeout': 'Der Anbieter hat nicht geantwortet. Bitte später erneut versuchen.',
  'campaign.sip.test.busy':
    'Die Verbindung wurde gerade erst geprüft. Bitte warten Sie einen Moment und versuchen Sie es dann erneut.',
  'error.sip.password_required': 'Bitte das Passwort des Telefonieanbieters eingeben.',
  'error.sip.incomplete': 'Bitte Server und Benutzernamen eingeben.',
} as const;
